import React from 'react';
import EditPDF from './EditPDF';
import EditImage from './EditImage';

const ItemEditMetadata = ({
                            mimeType,
                            ...props
                          }) => {
  const renderButton = () => {
    switch (mimeType) {
      case 'application/pdf':
        return <EditPDF {...props}/>;
      case 'image/gif':
      case 'image/jpeg':
      case 'image/tiff':
      case 'image/png':
        return <EditImage {...props}/>;
      default:
        return null;
    }
  };

  return renderButton();
};

export default ItemEditMetadata;